export type GlobalSidekickScope =
  | { kind: 'bot'; botId: string; name?: string }
  | { kind: 'workspace'; customerId?: string; name?: string };

/**
 * Navigation only retargets a minimized Sidekick. This tiny rule is kept pure
 * because losing it silently makes an open Bot X panel start acting on Bot Y.
 */
export function sidekickScopeAfterNavigation(
  active: GlobalSidekickScope | null,
  route: GlobalSidekickScope | null,
  expanded: boolean,
): GlobalSidekickScope | null {
  return expanded ? active : route;
}
